import { settingBucket } from './helpers'

const createListData = (data) => {
  const timing = {}
  const list = {}
  let total = 0
  data.forEach((hit) => {
    if ((!Object.hasOwn(list, hit.endpoint))) {
      list[hit.endpoint] = 1
    } else {
      list[hit.endpoint] += 1
    }
    total++

    if (!timing[hit.endpoint]) {
      timing[hit.endpoint] = {
        items: [],
        avg: 0
      }
    }
  })
  list.sumHits = total
  return list
}

const createDetailData = (data) => {
  return data
}

const createPieData = (data) => {
  delete data.sumHits
  const DataList = Object.keys(data).map((key) => {
    // console.log(key)
    return {
      name: key,
      value: data[key]
    }
  })
  return DataList
}

const filterData = (data, input) => {
  const bucket = settingBucket(input)
  data.forEach((hit) => {
    // Graphing data
    let found = false
    let count = 0
    while (!found && count < bucket.length) {
      if (hit.ts > bucket[count].sob && hit.ts < bucket[count].eob) {
        found = true
        bucket[count].hits += 1
        if (!Object.hasOwn(bucket[count], hit.endpoint)) {
          bucket[count][hit.endpoint] = 1
        } else {
          bucket[count][hit.endpoint]++
        }
      } else {
        count++
      }
    }
  })
  // bucket.push(list)
  return bucket
}
// eslint-disable-next-line
export default {
  filterData,
  createPieData,
  createListData,
  createDetailData
}
